import {useState} from 'react';

type useIsFormUntouchedTypes = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  watch: any;
  displayFields: {[key: string]: boolean};
  debug?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  defaultValues?: {[key: string]: any};
};

export function useIsFormTouched({
  watch,
  displayFields,
  debug,
  defaultValues,
}: useIsFormUntouchedTypes) {
  const [untouchedValues, setUntouchedValues] = useState<{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
  }>(defaultValues || {});

  const getIsFormTouched = () => {
    if (!Object.keys(untouchedValues)) {
      return false;
    }

    return Object.keys(untouchedValues).some(field => {
      if (!displayFields[field] || watch(field) === undefined) {
        return false;
      }

      if (watch(field)?.value && untouchedValues[field]?.value) {
        if (debug) {
          console.log({
            res: untouchedValues[field]?.value !== watch(field)?.value,
            [field]: {form: watch(field), untouched: untouchedValues[field]},
          });
        }

        return untouchedValues[field]?.value !== watch(field)?.value;
      }

      // if (watch(field) instanceof Date || watch(field) instanceof moment) {
      //   if (debug) {
      //     console.log({
      //       res: !moment(untouchedValues[field]).isSame(watch(field), 'day'),
      //       [field]: {form: watch(field), untouched: untouchedValues[field]},
      //     });
      //   }
      //   return !moment(untouchedValues[field]).isSame(watch(field), 'day');
      // }

      if (watch(field) instanceof Array || watch(field) instanceof Object) {
        if (debug) {
          console.log({
            res: JSON.stringify(untouchedValues[field]) !== JSON.stringify(watch(field)),
            [field]: {form: watch(field), untouched: untouchedValues[field]},
          });
        }

        return JSON.stringify(untouchedValues[field]) !== JSON.stringify(watch(field));
      }

      if (debug) {
        console.log({
          res: untouchedValues[field] !== watch(field),
          [field]: {form: watch(field), untouched: untouchedValues[field]},
        });
      }

      return untouchedValues[field] !== watch(field);
    });
  };

  return {
    setUntouchedValues,
    isFormTouched: getIsFormTouched(),
  };
}
